module.exports = __webpack_public_path__ + "img/LogoApp.49843718.svg";